import logoImage from './../../images/crowcloud.png';

export default class LoginController {

    static get $inject() {
        return ['$scope', '$state', 'AuthService', 'AlertsService'];
    }

    constructor($scope, $state, AuthService, AlertsService) {

        this.$scope = $scope;
        this._$state = $state;
        this._AuthService = AuthService;
        this._AlertsService = AlertsService;
        this._AlertsService.add = this._AlertsService.add.bind(this._AlertsService);

        this.item = {login: ''/*, accessKey: $stateParams.accessKey*/};
    }

    // --- VM Helpers -----------------

    submit() {
        this._AuthService.createAccount(this.item)
            .then(() => {
                this._$state.go('^.login');
            })
            .catch((e) => {
                this.$scope.modelState = e.data;
                if (e.data.message) {
                    this.addAlert(e.data.message);
                }

            })
    }


    get logoImage() {
        return logoImage;
    }
}












/** WEBPACK FOOTER **
 ** ./src/guest/createAccount/controller.js
 **/